module.exports = "/_next/static/images/c2903f667fe7d54470379acd2d6779cd-slide-2.png";